// extracted by mini-css-extract-plugin
module.exports = {"headlineAndSublineUppercase":"teaser-tiles_headlineAndSublineUppercase__EvoIb","twyfordHeadlineAndSubline":"teaser-tiles_twyfordHeadlineAndSubline__j4_kU"};